/**
 * Site plan (Asendiplaan) highlighting for the apartment popup.
 *
 * The inline SVG (assets/img/site-plan.svg) lives in [data-apt-map]. Buildings
 * are marked with data-building="<ACF building value>"; units inside a
 * building with data-number="<apartment number>". When apartment data loads
 * (apt-popup:loaded) the matching unit(s) get .is-active and the apartment
 * number is placed on their centroid. A building without unit drawings gets
 * its outline highlighted instead.
 */
(function ($) {
	'use strict';

	var SVG_NS = 'http://www.w3.org/2000/svg';

	function normalise(value) {
		return $.trim(String(value || '')).toLowerCase();
	}

	function clear($popup) {
		var $map = $popup.find('[data-apt-map]');
		$map.find('.is-active').removeClass('is-active');
		$map.find('[data-apt-map-label]').attr('hidden', '').text('');
	}

	/**
	 * Area-weighted centroid of a straight-line path (absolute M/L/H/V/Z),
	 * in the path's own user space. Returns null for anything else.
	 */
	function polygonCentroid(d) {
		if (/[^MLHVZmlhvz0-9.\s,-]/.test(d)) {
			return null;
		}
		var tokens = d.match(/[MLHVZmlhvz]|-?[\d.]+/g) || [];
		var pts = [];
		var cmd = null;
		var x = 0;
		var y = 0;
		var i = 0;

		while (i < tokens.length) {
			var t = tokens[i];
			if (/[A-Za-z]/.test(t)) {
				cmd = t;
				i++;
				if (cmd === 'Z' || cmd === 'z') {
					continue;
				}
			}
			if (cmd === 'M' || cmd === 'L') {
				x = parseFloat(tokens[i]); y = parseFloat(tokens[i + 1]); i += 2;
			} else if (cmd === 'm' || cmd === 'l') {
				x += parseFloat(tokens[i]); y += parseFloat(tokens[i + 1]); i += 2;
			} else if (cmd === 'H') {
				x = parseFloat(tokens[i]); i++;
			} else if (cmd === 'h') {
				x += parseFloat(tokens[i]); i++;
			} else if (cmd === 'V') {
				y = parseFloat(tokens[i]); i++;
			} else if (cmd === 'v') {
				y += parseFloat(tokens[i]); i++;
			} else {
				return null;
			}
			pts.push([x, y]);
		}

		if (pts.length < 3) {
			return null;
		}

		var area = 0;
		var cx = 0;
		var cy = 0;
		for (var j = 0; j < pts.length; j++) {
			var p0 = pts[j];
			var p1 = pts[(j + 1) % pts.length];
			var cross = p0[0] * p1[1] - p1[0] * p0[1];
			area += cross;
			cx += (p0[0] + p1[0]) * cross;
			cy += (p0[1] + p1[1]) * cross;
		}
		area /= 2;
		if (!area) {
			return null;
		}
		return { x: cx / (6 * area), y: cy / (6 * area), area: Math.abs(area) };
	}

	function shapeCentre(el) {
		var c = polygonCentroid(el.getAttribute('d') || '');
		if (c) {
			return c;
		}
		try {
			var box = el.getBBox();
			return { x: box.x + box.width / 2, y: box.y + box.height / 2, area: box.width * box.height };
		} catch (e) {
			return null;
		}
	}

	/**
	 * Place the number label on the centroid of the active shapes. Needs the
	 * SVG to be rendered (getCTM), so this runs when the map pane is visible.
	 */
	function positionLabel($popup) {
		var svg   = $popup.find('[data-apt-map] svg')[0];
		var label = svg ? svg.querySelector('[data-apt-map-label]') : null;
		var text  = label ? label.getAttribute('data-text') : '';

		if (!svg || !label || !text || !svg.getCTM || $popup.find('.apt-popup__pane--map').is(':hidden')) {
			return;
		}

		var active = svg.querySelectorAll('.apt-map__unit.is-active');
		if (!active.length) {
			label.setAttribute('hidden', '');
			return;
		}

		var parentCTM = (label.parentNode.getCTM && label.parentNode.getCTM()) || svg.getCTM();
		var sumX = 0;
		var sumY = 0;
		var sumA = 0;

		for (var i = 0; i < active.length; i++) {
			var c = shapeCentre(active[i]);
			if (!c) {
				continue;
			}
			var pt = svg.createSVGPoint();
			pt.x = c.x;
			pt.y = c.y;
			// unit space → viewport → label parent space
			pt = pt.matrixTransform(parentCTM.inverse().multiply(active[i].getCTM()));
			var w = c.area || 1;
			sumX += pt.x * w;
			sumY += pt.y * w;
			sumA += w;
		}

		if (!sumA) {
			label.setAttribute('hidden', '');
			return;
		}

		label.setAttribute('x', (sumX / sumA).toFixed(2));
		label.setAttribute('y', (sumY / sumA).toFixed(2));
		label.textContent = text;
		label.removeAttribute('hidden');
	}

	function highlight($popup, data) {
		clear($popup);

		var svg = $popup.find('[data-apt-map] svg')[0];
		if (!svg || !data) {
			return;
		}

		var building = null;
		var buildings = svg.querySelectorAll('[data-building]');
		for (var i = 0; i < buildings.length; i++) {
			if (normalise(buildings[i].getAttribute('data-building')) === normalise(data.building)) {
				building = buildings[i];
				break;
			}
		}
		if (!building) {
			return;
		}

		var unit  = normalise(data.unit || data.number);
		var units = unit ? building.querySelectorAll('.apt-map__unit[data-number="' + unit + '"]') : [];

		if (units.length) {
			$(units).addClass('is-active');
			var label = svg.querySelector('[data-apt-map-label]');
			if (label) {
				label.setAttribute('data-text', data.number || data.unit || '');
			}
			positionLabel($popup);
		} else if (!building.querySelector('.apt-map__unit')) {
			// No unit drawings for this building → highlight the whole outline
			building.classList.add('is-active');
		}
	}

	$(document)
		.on('apt-popup:open', '.apt-popup', function () {
			clear($(this));
		})
		.on('apt-popup:loaded', '.apt-popup', function (event, data) {
			highlight($(this), data);
		})
		.on('apt-popup:tab', '.apt-popup', function (event, name) {
			if (name === 'map') {
				positionLabel($(this));
			}
		});

	$(window).on('resize', function () {
		$('.apt-popup.is-open').each(function () {
			positionLabel($(this));
		});
	});

})(jQuery);
